import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Organization } from '@paragon/contract-library';

type OrganizationsState = readonly Organization[];

const initialState: OrganizationsState = [];

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    organizationCreate: (state, action: PayloadAction<Organization>) => {
      state.push(castDraft(action.payload));
    },
    organizationUpdate: (state, action: PayloadAction<Organization>) => {
      const index = state.findIndex((org) => org.name === action.payload.name);
      state[index] = castDraft(action.payload);
    },
    organizationCustomersSet: (
      state,
      action: PayloadAction<{
        readonly name: string;
        readonly customers: readonly string[];
      }>,
    ) => {
      for (const organization of state) {
        if (organization.name === action.payload.name) {
          organization.customers = castDraft(action.payload.customers);
        }
      }
    },
    organizationSet: (state, action: PayloadAction<readonly Organization[]>) => action.payload,
  },
});

export const { organizationCreate, organizationUpdate, organizationCustomersSet, organizationSet } =
  organizationsSlice.actions;
export const organizations = organizationsSlice.reducer;
